import { Currency } from "../Models/Currency";

export const GOT_CURRENCY_FINALLY = (currency: Currency) => {
  return { type: "GOT_CURRENCY_FINALLY", payload: currency };
};
